import { Star } from 'lucide-react'
import { useState } from 'react'

export default function StarRatingInput({
  value,
  onChange,
}: {
  value: number
  onChange: (nextValue: number) => void
}) {
  const [hovered, setHovered] = useState<number | null>(null)
  const activeValue = hovered ?? value

  return (
    <div className="flex items-center gap-2">
      {Array.from({ length: 5 }, (_, index) => {
        const rating = index + 1
        const active = rating <= activeValue

        return (
          <button
            key={rating}
            type="button"
            aria-label={`Rate ${rating} stars`}
            onMouseEnter={() => setHovered(rating)}
            onMouseLeave={() => setHovered(null)}
            onClick={() => onChange(rating)}
            className="rounded-full p-1 text-slate-300 transition hover:scale-105"
          >
            <Star className={active ? 'fill-amber-400 text-amber-400' : 'text-slate-300'} />
          </button>
        )
      })}
    </div>
  )
}
